import React from 'react';
import styles from './style.module.css';
import Tooltip from '../tooltip';

export default ({
    input,
    meta: {
        error,
        submitFailed
    } = {},
    name = input.name ? input.name : 'input',
    label = false,
    tooltip = false,
    autoComplete = 'off',
    readOnlyValue = false,
    prefix = false,
    min = null,
    max = null,
    placeholder = ''
} = {}) => (
    <div
        className={
            readOnlyValue !== false ?
                styles.readOnly
                : submitFailed && error ?
                styles.inputError
                :
                styles.container
        }
    >
        {
            label &&
            <div className={styles.labelContainer}>
                <label
                    htmlFor={name}
                    className={styles.label}
                >
                    {label}
                </label>
                {
                    tooltip &&
                    <Tooltip content={tooltip}/>
                }
            </div>
        }
        <div className={styles.inputContainer}>
            {
                prefix &&
                <span className={styles.prefix}>{prefix}</span>
            }
            <textarea
                {...input}
                id={name}
                value={readOnlyValue !== false ? readOnlyValue : input.value}
                readOnly={readOnlyValue !== false}
                onKeyPress={e => {
                    if (e.key === 'Enter') e.preventDefault();
                }}
                className={`${styles.input} ${styles.textarea}`}
                autoComplete={autoComplete}
                min={min}
                max={max}
                placeholder={placeholder}
            >
            </textarea>
            {
                submitFailed && error &&
                <span className={styles.errorDot}/>
            }
        </div>
        {
            submitFailed && error &&
            error.map((message, i) => <span key={i} className={styles.errorMessage}>{message}</span>)
        }
    </div>
);
